////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const logUsers = {
	postLogUsers: (filters = {}, queryParams = { page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_LOG_USERS,
		payload: {
			filters,
			queryParams,
		},
	}),
	postLogUsersSuccess: (data) => ({
		type: ActionsTypes.POST_LOG_USERS_SUCCESS,
		payload: { data },
	}),
	postLogUsersFailure: () => ({
		type: ActionsTypes.POST_LOG_USERS_FAILURE,
		payload: {},
	}),

	resetLogUsers: () => ({
		type: ActionsTypes.RESET_LOG_USERS,
	}),
}

export default logUsers
